module.exports = __webpack_public_path__ + "assets/952a11163665e0b937cd0874351e96ed.png";